import Dashboardcontent from "components/dashboard/DashboardContent";
import React from "react";

const Dashboard = () => {
  return (
    <>
      <div className="main-contents">
        <h1>Dashboard</h1>
        <Dashboardcontent />
      </div>
    </>
  );
};

export default Dashboard;
